<template>
    <div class="animated fadeIn">  
        <b-card v-show="showList">
            <div slot="header">Inventory On Transfer
                <div class="card-header-actions">
                <b-button variant="btn btn-primary mr-1" @click="onSelectLkuTrfout()">Select</b-button>
                <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col md="8">
                <b-form-group label-cols-lg=2 label="Filter">
                     <b-form-row>
                        <b-col md="3"><b-form-input v-model="tblData.itemcode" placeholder="Code" value="" @keyup.13.native="refresh()"></b-form-input></b-col>
                        <b-col md="5"><b-form-input v-model="tblData.itemname" placeholder="Name" value="" @keyup.13.native="refresh()"></b-form-input></b-col>
                        <b-col md="3"><b-form-input v-model="tblData.headcategory" placeholder="Head Category" value="" @keyup.13.native="refresh()"></b-form-input></b-col>
                        <b-col md="1">
                        <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear</b-button>
                        </b-col>
                    </b-form-row>   
                </b-form-group>
                </b-col>
            </b-row>

            <b-table
                class="mb-0"
                ref="table"
                outlined  responsive hover small
                style="font-size:smaller;" 
                :items="data"
                :fields="tblFields"
                @row-clicked="rowClicked"
            >
                <template v-slot:cell(tanggal)="data">
                {{ data.item.tanggal | moment("DD MMM YYYY") }}
                </template>
                <template v-slot:cell(itemname)="data">
                {{data.item.partnumber}} | {{data.item.itemname}}
                </template>
                <template v-slot:cell(qtyTrfOut)="data">
                {{data.item.qtyTrfOut}} &nbsp; {{data.item.invunitom}}
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="6">
                <div>
                    Showing
                    {{(tblData.page - 1) * tblData.limit + 1}}
                    to
                    {{tblData.page * tblData.limit}}
                    of
                    {{tblData.total}}
                    entries
                </div>
                </b-col>
                <b-col cols="6">            
                <b-pagination
                    align="right"
                    :total-rows="tblData.total"
                    :per-page="tblData.limit"
                    v-model="tblData.page"
                ></b-pagination>
                </b-col>
            </b-row>
            </b-card>      
        <b-card v-show="showForm">
            <div slot="header">
                Inventory Transfer In Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-form>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Inv. Trf. Number</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.nomor" ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                            <b-input-group-prepend><label style="width:160px;">Transfer from Store</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.fromNameStore" ></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>    
                    <b-input-group >
                        <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian" placeholder="Note/Remark" readonly></b-form-input>
                    </b-input-group>
                    <b-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Create By</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.createby" ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                            <b-input-group-prepend><label style="width:160px;">Transfer Date</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.tanggal" type="date" ></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>    
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                        <b-input-group-prepend><label style="width:160px;">Trannsfer To Store</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.toNameStore" ></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Received Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.invTrfReceivDate" type="date" :max="maxRecivedDate" :state="!$v.model.invTrfReceivDate.$error"></b-form-input>                                        
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Received By</label></b-input-group-prepend>
                        <b-form-input v-model="model.invTrfReceivby" :state="!$v.model.invTrfReceivby.$error"></b-form-input>                                        
                    </b-input-group> 
                </b-col>
              </b-row>
                <div class="report-wraper">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                                <th width="20px">No.</th>
                                <th width="180px">Item Code</th>
                                <th>Item Name</th>
                                <th width="100px">Shelf No</th>
                                <th width="100px">Quantity<br>Transfered </th>
                                <th width="100px">Quantity<br>Received</th>
                                <th width="100px">Quantity<br>Broken</th>
                                <th width="100px">Quantity<br>Lost</th>
                                <th width="100px">Quantity<br>Expired</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in Lines" :key="row.invTrfDtlKey">
                                <td>{{idx+1}}</td>
                                <td>{{row.partnumber}}</td>
                                <td>{{row.itemname}}</td>
                                <td style="text-align:center;">
                                    <b-input-group>
                                        <b-form-input v-model="row.trfShelfNo"  type="text"></b-form-input>
                                    </b-input-group>
                                </td>
                                <td  style="text-align:center;">{{row.qtyTrfOut}} {{row.invunitom}}</td>
                                <td style="text-align:center;">
                                    <b-input-group :class="{ 'form-group--error': row.errorQty || row.errorNotBalance }">
                                        <b-form-input v-model="row.qtyTrfIn"  type="number" :min="0" ></b-form-input>
                                    </b-input-group>
                                </td>
                                <td style="text-align:center;">
                                    <b-input-group :class="{ 'form-group--error': row.errorQty }">
                                        <b-form-input v-model="row.qtyBroken"  type="number" :min="0" ></b-form-input>
                                    </b-input-group>
                                </td>
                                <td style="text-align:center;">
                                    <b-input-group :class="{ 'form-group--error': row.errorQty }">
                                        <b-form-input v-model="row.qtyLost"  type="number" :min="0" ></b-form-input>
                                    </b-input-group>
                                </td>
                                <td style="text-align:center;">
                                    <b-input-group :class="{ 'form-group--error': row.errorQty }">
                                        <b-form-input v-model="row.qtyExpired"  type="number" :min="0" ></b-form-input>
                                    </b-input-group>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>                  

            </b-form>
            <b-row class="justify-content-center mt-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>

        </b-card>       
    </div>
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
    .form-group--error input, .form-group--error textarea, .form-group--error input:focus, .form-group--error input:hover {
        border-color: #f79483;
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import invtrf from "../../apis/logistic_inv_trf";
import { validationMixin } from "vuelidate";
import { required, requiredUnless, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
    components: { myNumber},
    mixins: [validationMixin],
    validations: {
            model: {
                invTrfKey: { required },
                invTrfReceivDate: { required },
                invTrfReceivby: { required },
            },
            lines:{
                $each: {
                    qtyReceivedTotal: { required },
                }
            }

                
    }, 
    data() {
        return {
            saveEnabled:true,
            horizontal:true,
            showList:true,
            showForm:false,
            lkuItemShow:false,
            lkuTrfOutShow:false,
            lkuSalesShow:false,
            updateDimHdr:false,
            updateDimDtl:true,
            tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
            uanguser: this.$store.state.user.matauang,
            selectTrf:{},
            model:{idStore:'',invTrfReceivby:'',invTrfReceivDate:'',uraian:'',nomor:''},
            Lines:[],
            tblData: {
                page: 1,
                limit: 20,
                total: 0,
                sortBy: null,
                sortDesc: false,
                outstand: 1
            },
            listItemRequested : [],
            issuedGroups: [],
            Warehouse : [],
            
        };
    },
    computed: {
        dimension(){
        return this.$store.state.dimension;
        },
        invalidModel() {
            this.$v.model.$touch();
            return this.$v.model.$invalid;
        },
        invalidLines() {
            let result =false;
            let line;
            let rcvQty=0;
            
            for (let index = 0; index < this.Lines.length; index++) {
                line = this.Lines[index];
                
                rcvQty=parseFloat(line.qtyTrfIn)+ parseFloat(line.qtyLost)+parseFloat(line.qtyBroken)+parseFloat(line.qtyExpired);
                if (rcvQty==0) {
                    result=true;
                    this.Lines[index].errorQty = true;
                    break;
                } else {
                    if (line.qtyTrfOut!==rcvQty) {
                    result=true;
                    this.Lines[index].errorNotBalance = true;
                    break;
                    }
                }                    
            }
            return result;
        },
        tblFields(){
            const fields =  [
                {
                    key: "nomor",
                    thStyle: "width:100px",
                    label: "Transfer Doc. Number",
                    sortable: true
                },
                {
                    key: "tanggal",
                    thStyle: "width:90px",
                    label: "Transfer Date",
                    sortable: true
                },
                {
                    key: "fromNameStore",
                    thStyle: "width:150px",
                    label: "From Store/Warehouse",
                    sortable: true
                },
                {
                    key: "toNameStore",
                    thStyle: "width:150px",
                    label: "To Store/Warehouse",
                    sortable: true
                },
                {
                    key: "uraian",
                    label: "Remark/Description",
                },
                {
                    key: "itemname",
                    label: "Item Inventory",
                    thStyle: "width:250px",
                    sortable: true
                },
                {
                    key: "qtyTrfOut",
                    label: "Quantity",
                    thStyle: "width:100px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
            ];
            return fields;
        },
        maxRecivedDate(){
            return moment(new Date()).format('YYYY-MM-DD');
        }
    },
    methods: {
        data: async function() {
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            const list = await invtrf.list(this.tblData);  
            console.log('list --',list)    
            
            return list;
        },
        save: async function () {
            console.log('this.invalidLines',this.invalidLines)
            if (!this.saveEnabled) {
                toastr.error('View mode cannot be Saved');
                return;
            }
            if (this.invalidModel) {
                console.log('validation : ', this.$v.model);
                console.log('model obj : ',this.model);
                toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            } else if (this.invalidLines) {
                toastr.error('Total Quantity can not be Zero and Total Quantity must be equal with Quantity Transfer ', "ERROR MESSAGE");
            } else {
                try {
                       const row={};
                        row.invTrfKey = this.model.invTrfKey;
                        row.invTrfReceivDate = this.model.invTrfReceivDate;
                        row.invTrfReceivby = this.model.invTrfReceivby;
                        row.lines=this.Lines;
                        if (row.lines.length>0) {
                            await invtrf.saveTrfin(row);
                            toastr.success("Complete successfully", "Save Request");
                            this.close();
                        } else {
                            toastr.error('Please fill at least 1(one) Recining Detail', 'ERROR MESSAGE');
                        }
                } catch (error) {
                    console.log('error : ', error);
                    toastr.error(JSON.stringify(error), "Save Request Error");                
                }

            }
        },
        rowClicked(record, index) {
            console.log('record',record)
            if ((this.selectTrf || {}).invTrfKey==record.invTrfKey) {
                // this.edit();
                this.onSelectLkuTrfout();
            } else {
                if ((this.selectTrf) && (this.selectTrf._rowVariant)) {
                    delete this.selectTrf._rowVariant;
                }
                this.selectTrf = record;
                record._rowVariant= 'info';
                this.$forceUpdate();

            }
        },
        async onSelectLkuTrfout() {
            if(this.selectTrf.invTrfKey) {
                for (var key in this.model) {
                    this.model[key] = '';
                }

                const data = await invtrf.detail(this.selectTrf); 
                
                const row = data[0][0];
                for (const key in row) {
                    if (row.hasOwnProperty(key)) {
                        this.model[key] = row[key];
                    }
                }
                this.Lines = data[1]; 
                console.log('this.Lines',this.Lines)
                this.showForm=true;
                this.showList=false;
            }
            
        },
        refresh(ctx) {
            this.$refs.table.refresh();
        },
        closeFrm(){
            this.showForm=false;
            this.showList=true;
            this.model = {};
            this.selectTrf = {};
        },
        close(){
            router.push({name:'logistic.transferin'});
        }
    }
};
</script>
